import { connect } from 'react-redux';
import ui from 'redux-ui';
import autobind from 'core-decorators/lib/autobind';
import { FormattedMessage } from 'react-intl';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowVideoListItemPublisher } from 'shared/selectors/app-settings';

import SubscribeShownBIOverlay from '../../bi/_subscribe-shown-bi-overlay';
import Button from 'widget/components/button/button';
import Icon from 'shared/components/icon/icon';

import styles from '../main-video.styl';

import commonTranslations from 'shared/translations/overlay-common-translations';


@connect(state => ({
  canShowVideoListItemPublisher: canShowVideoListItemPublisher(state),
}))
@ui()
@WixConnect(styles)
export default class OverlayMainVideoMobile extends SubscribeShownBIOverlay {

  static displayName = 'OverlayMainVideoMobile';

  static defaultProps = {
    onPlayClick: _.noop,
    onPurchaseClick: _.noop,
    onSubscribeClick: _.noop,

    canShowVideoListItemPublisher: React.PropTypes.bool,
  };

  get title() {
    const { onTitleClick } = this.props;
    const titleText = this.titleText;

    if (!titleText) {
      return null;
    }

    return (
      <div styleName="title">
        <span styleName="title-text"
              onClick={onTitleClick}>
          {titleText}
        </span>
        {this.preview}
      </div>
    );
  }

  get previewText() {
    const { beenPlayed } = this.props;
    const minVideoPriceInfo = this.minVideoPriceInfo;

    if (!beenPlayed) {
      if (this.isChannelCoverView && (this.subscriptionPriceInfo || minVideoPriceInfo)) {
        return <FormattedMessage {...commonTranslations.preview} />;
      }

      if (minVideoPriceInfo) {
        return <FormattedMessage {...commonTranslations.trailer} />;
      }
    }

    return null;
  }

  get preview() {
    const previewText = this.previewText;

    if (!previewText) {
      return null;
    }

    return (
      <span styleName="preview-text">
        ({previewText})
      </span>
    );
  }

  get publisher() {
    const { canShowVideoListItemPublisher } = this.props;

    if (!canShowVideoListItemPublisher) {
      return null;
    }

    const publisherText = this.publisherText;

    if (!publisherText) {
      return null;
    }

    return (
      <div styleName="publisher">
        <span styleName="publisher-text">{publisherText}</span>
      </div>
    );
  }

  get playButton() {
    const playButtonText = this.playButtonText;

    if (!playButtonText) {
      return null;
    }

    return (
      <Button styleName="button"
              onClick={this.props.onPlayClick}>
        <Icon styleName="play-icon"
              name="arrow-right-filled" />
        <span>
          {playButtonText}
        </span>
      </Button>
    );
  }

  @autobind
  subscribe() {
    const { onSubscribeClick, channelData } = this.props;
    this.sendSubscribeClickedBI();
    onSubscribeClick(channelData);
  }

  get subscribeButton() {
    const subscribeButtonText = this.subscribeButtonText;

    if (!subscribeButtonText) {
      return null;
    }

    return (
      <Button styleName="button"
              onClick={this.subscribe}>
        {subscribeButtonText}
      </Button>
    );
  }

  get purchaseButton() {
    const purchaseButtonText = this.purchaseButtonText;

    if (!purchaseButtonText) {
      return null;
    }

    return (
      <Button styleName="button"
              onClick={this.props.onPurchaseClick}>
        {purchaseButtonText}
      </Button>
    );
  }

  render() {
    const {
      beenPlayed,
      ended,
      className,
    } = this.props;

    const overlayClick = beenPlayed || ended ? this.playSelectedVideo : _.noop;
    const styles = this.getOpacityStyles();

    return (
      <div style={styles}
           styleName="overlay"
           className={className}
           onClick={overlayClick}>
        {this.title}
        {this.publisher}

        <div styleName="buttons">
          {this.playButton}
          {this.subscribeButton || this.purchaseButton}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/main-video/main-video.js